import { Box, Image, SpacerNew, TextNew } from '@jfs/ui-new'
import { styles } from './styles'
const pdfImage = require('../../assets/images/Icons/pdfImage.png')

const { PUBLIC_URL = '' } = process.env

export const onPress = (item: any) => {
  let downloadLink = item.filePath
  window.open(`${PUBLIC_URL}` + downloadLink, '_blank')
}

export const PdfItem = ({ item, index, isDesktop }: any) => {
  return (
    <Box {...styles.pdfContainer(index, isDesktop)} onPress={() => onPress(item)}>
      <Box justifyContent="center">
        <Image source={pdfImage} height={50} width={45} resizeMode={'contain'} />
      </Box>
      <SpacerNew direction="horizontal" size={20} />
      <Box alignSelf="center" f={1}>
        <TextNew {...styles.titleText(isDesktop)} title={item?.text} />
      </Box>
    </Box>
  )
}
